import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DisconnectedMessageContainer } from '../styles';
import { ReactComponent as ConnectivityOfflineImage } from '../../../../assets/img/remoteControl/connectivityOffline.svg';
import { Button } from '~/components';
import { ModalDisconnectedMachineInfo } from '~/components/ModalsRemoteControl/DisconnectedMachineInfo';

export function DisconnectedMachineContent(): ReactElement {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);

  function onCloseModal() {
    setOpenModal(false);
  }

  function onClickOpenModal() {
    setOpenModal(true);
  }

  return (
    <>
      <ModalDisconnectedMachineInfo
        isOpen={openModal}
        onClose={onCloseModal}
      />
      <DisconnectedMessageContainer>
        <div>
          <ConnectivityOfflineImage style={{ height: '130', width: '130' }} />
        </div>
        <h2>{t('pareceMaquinaOffline')}</h2>
        <div style={{
          flexDirection: 'column',
          padding: '0 12px',
          maxWidth: '310px',
          gap: '8px',
        }}
        >
          <p>{t('pareceMaquinaOfflineInfo')}</p>
          <Button
            variant="rc-blue"
            style={{
              maxWidth: '168px',
              fontSize: '11px',
              padding: '8px 12px',
              borderRadius: '4px',
              letterSpacing: '0',
              lineHeight: '150%',
              textTransform: 'none',
            }}
            onClick={onClickOpenModal}
          >
            {t('comoVerificarMaquina')}
          </Button>
        </div>
      </DisconnectedMessageContainer>
    </>
  );
}
